module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department_sp02-e11cb6d3864841c46389ce3f79e24787.jpg";